import React, {useEffect, useRef} from 'react';
import {Modal, View, Image, Animated} from 'react-native';
import {AnimatedCircularProgress} from 'react-native-circular-progress';

import Text from '../Text';

import {Images} from '../../../utils/Images';
import {useTheme, useThemedStyles} from '../../../theme';

import makeStyles from './styles';
import {DLog} from '../../../utils/HelperMethods';
import {tID} from '../../../utils/TestIdHelper';

const LogoLoader = ({
  title = 'We’re processing your order!',
  description = 'Hang tight, and please don’t close your app!',
  visible = true,
  testID = tID('LogoLoader-Modal-Main'),
  timing = 4000,
  ...props
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const progressRef = useRef(
    new AnimatedCircularProgress({
      prefill: 0,
      useNativeDriver: false,
    }),
  );
  useEffect(() => {
    const repeatAnim2 = Animated.loop(progressRef.current.animate(100, timing));
    repeatAnim2.start();
    return () => {
      repeatAnim2.stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only looped animation; animate() self-starts, so re-firing on timing would restart the loop mid-cycle
  }, []);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      testID={testID}
      onRequestClose={() => DLog('overridden onRequestClose')}
    >
      <View
        testID={tID('LogoLoader-View-Container')}
        style={styles.centeredView}
      >
        <View style={styles.modalView}>
          <AnimatedCircularProgress
            size={100}
            width={30}
            fill={100}
            ref={progressRef}
            tintColor={colors.accentStrong}
            backgroundColor={colors.borderMuted}
            style={styles.animatedCircularProgress}
            rotation={-23} //needed for it to start at the corner of logo
          />
          <View style={styles.logoContainer}>
            <Image
              testID={tID('LogoLoader-Image-ExcludedLogo')}
              source={Images.excludedLogo}
              style={styles.excludedLogo}
              resizeMode="contain"
            />
          </View>
          <Text
            testID={tID('LogoLoader-Text-Title')}
            variation="Body1SemiBold"
            color={colors.textTertiary}
            style={styles.textStyle}
          >
            {title}
          </Text>
          <Text
            testID={tID('LogoLoader-Text-Description')}
            variation="Body1Regular"
            color={colors.textMuted}
            style={styles.textStyle}
          >
            {description}
          </Text>
          <View
            testID={tID('LogoLoader-View-ChildrenContainer')}
            style={styles.buttonsContainer}
          >
            {props.children}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default LogoLoader;
